let Choices = require( 'choices.js' );
let forms   = require( './forms' );
let utils 	= require( './utils' );

let submit_proposal = (function( $ ) {

	let $form;

	let $form_nav;

	let form_nav_choices;

	let $abstract_parts;

	let $move_to_submitted_button;

	let _init = function() {
		$form = $( '#individual_presentation_form' );

		if ( $form.length > 0 ) {
			$form.find( 'a.add-co-presenter' ).on( 'click', _add_co_presenter );
			$form.find( 'a.add-co-author' ).on( 'click', _add_co_author );

			_update_co_person_html( 'co_presenter' );
			_update_co_person_html( 'co_author' );
		}

		$form_nav = $( 'select[name="form-nav"]' );

		if ( $form_nav.length > 0 ) {
			form_nav_choices = new Choices( $form_nav[0], {
				searchEnabled : false,
				shouldSort: false
			} );
			$form_nav.on( 'change', _navigate_form );

			$( window ).on( 'scroll', _maybe_stick_nav );
			$( window ).smartresize( _maybe_change_nav_width );
		}

		let abstract_selector = 'textarea.abstract-part';

		if ( 'ped' === $form.find( '#individual_presentation_form-proposal_type' ).val() ) {
			abstract_selector += '.ped';
		} else {
			abstract_selector += '.non-ped';
		}

		$abstract_parts = $( abstract_selector );

		if ( $abstract_parts.length > 0 ) {
			_update_word_count();

			$abstract_parts.on( 'keydown', _update_word_count );
			$abstract_parts.on( 'keyup', _update_word_count );
			$abstract_parts.on( 'change', _update_word_count );
		}

		$move_to_submitted_button = $( 'a.proposal-to-submitted' );

		if ( $move_to_submitted_button.length > 0 ) {
			$move_to_submitted_button.on( 'click', _move_to_submitted );
		}

		if ( utils.viewport_size().width < 992 ) {
			_move_abstract_tooltips();
		} else {
			$( window ).smartresize( _maybe_move_abstract_tooltips );
		}
	};

	let _move_to_submitted = function( e ) {
		e.preventDefault();

		let data = {
			action: 'crate_move_proposal_to_submitted',
			nonce: ScriptData.crate_move_proposal_to_submitted_nonce,
			proposal: $( this ).data( 'proposal' ),
			redirect: $( this ).attr( 'href' ),
		};

		$( '.ajax-spinner' ).addClass( 'active' );
		$( 'body' ).addClass( 'crate-loading' );

		$.post( ScriptData.ajaxurl, data, _move_to_submitted_response );
	};

	let _move_to_submitted_response = function( response ) {
		if ( response.success ) {
			window.location.href = response.redirect;
		}
	};

	let _update_word_count = function( e ) {
		let total_words = 0;

		$abstract_parts.each( function() {
			let val = $( this ).val();

			if ( ! val ) {
				return; // Functional equivalent to `continue` in this context
			}

			let words = val.trim().split( ' ' );

			total_words += words.length;
		} );

		let $count = $( '.nav-section' ).find( '.count' );
		let words_remaining = parseInt( $count.data( 'total' ) ) - total_words;

		$count.text( words_remaining );

		if ( words_remaining < 0 ) {
			$count.addClass( 'invalid' );
		} else {
			$count.removeClass( 'invalid' );
		}
	};

	let _maybe_change_nav_width = function() {
		let $nav_section = $( '.nav-section' );

		if ( $nav_section.hasClass( 'fixed' ) ) {
			$nav_section.css( { width: $( '#submit-proposal-steps' ).outerWidth() } );
		}
	};

	let _maybe_stick_nav = function() {
		let $nav_section = $( '.nav-section' );
		let $steps_section = $( '.steps-section' );
		let $form_section = $( '.form-section' );

		if ( ! $nav_section.hasClass( 'fixed' ) ) {
			if ( $nav_section.offset().top < $( window ).scrollTop() ) {
				$nav_section.addClass( 'fixed' );
				$nav_section.css( { position: 'fixed', top: 0, width: $( '#submit-proposal-steps' ).outerWidth() } );
				$form_section.css( { 'margin-top': '100px' } );
			}
		} else {
			if ( $steps_section.offset().top + $steps_section.outerHeight() > $( window ).scrollTop() ) {
				$nav_section.removeClass( 'fixed' );
				$nav_section.css( { position: 'relative', top: '', width: 'auto' });
				$form_section.css( { 'margin-top': '' } )
			}
		}
	};

	let _navigate_form = function( e ) {
		$form_nav.off( 'change', _navigate_form );
		let value = $( this ).val();

		form_nav_choices.setChoiceByValue( 'Quick Navigation' );

		if ( value && value !== 'Quick Navigation' ) {
			let scroll_to = '#' + $( this ).data( 'form' ) + '-field-wrap-' + value;

			$( 'html, body' ).animate( {
				scrollTop: $( scroll_to ).offset().top - 120
			}, 1000 );
		}

		$form_nav.on( 'change', _navigate_form );
	};

	let _add_co_presenter = function( e ) {
		e.preventDefault();

		if ( e ) {
			_add_co_person( 'co_presenter', true );
		} else {
			_add_co_person( 'co_presenter' );
		}
	};

	let _add_co_author = function( e ) {
		e.preventDefault();

		if ( e ) {
			_add_co_person( 'co_author', true );
		} else {
			_add_co_person( 'co_author' );
		}
	};

	let _add_co_person = function( type, scroll_to ) {
		let form_id = $form.attr( 'id' );
		let $val_field = $( `#${form_id}-proposal_${type}s` );

		let fields = {
			first_name: $( `#${form_id}-proposal_${type}_first_name` ),
			last_name: $( `#${form_id}-proposal_${type}_last_name` ),
			email: $( `#${form_id}-proposal_${type}_email` ),
			organisation: $( `#${form_id}-proposal_${type}_organisation` ),
			country: $( `#${form_id}-proposal_${type}_country` ),
		};

		let error = false;

		let data = {};

		for ( let field_key in fields ) {
			if ( !fields.hasOwnProperty( field_key ) ) {
				continue;
			}

			data[ field_key ] = fields[ field_key ].val();

			if ( !data[ field_key ] || data[ field_key ] === 'Please select' ) {
				error = true;
				fields[ field_key ].closest( '.field-wrap' ).addClass( 'has-errors' );
				fields[ field_key ].on( 'change', function( e ) {
					if ( $( this ).val() ) {
						$( this ).closest( '.field-wrap' ).removeClass( 'has-errors' )
					}
				} );
			} else {
				fields[ field_key ].closest( '.field-wrap' ).removeClass( 'has-errors' );
			}
		}

		if ( error ) {
			return;
		}

		for ( let field_key in fields ) {
			if ( !fields.hasOwnProperty( field_key ) ) {
				continue;
			}

			fields[ field_key ].val( '' );

			let field_id = fields[ field_key ].attr( 'id' );

			if ( field_id in forms.choices ) {
				forms.choices[ field_id ].setChoiceByValue( 'Please select' );
			}
		}

		let new_value = [];

		let prev_value = $val_field.val();

		if ( prev_value ) {
			new_value = JSON.parse( prev_value );
		}

		new_value.push( data );

		$val_field.val( JSON.stringify( new_value ) );

		_update_co_person_html( type, scroll_to );
	};

	let _update_co_person_html = function( type, scroll_to ) {
		let $el = $( `#${type}s` );
		let html = '';

		let people_json = $( '#' + $form.attr( 'id' ) + '-proposal_' + type + 's' ).val();

		if ( people_json ) {
			let people = JSON.parse( people_json );
			let count = 1;

			for ( let person in people ) {
				if ( !people.hasOwnProperty( person ) ) {
					continue;
				}

				html += '<div class="person clearfix" data-id="' + person + '">' +
					count.toString() + '. ' +
					people[ person ].first_name + ' ' +
					people[ person ].last_name + ', ' +
					people[ person ].email + ', ' +
					people[ person ].organisation + ', ' +
					people[ person ].country +
					'<a href="#" class="remove">Remove</a>' +
					'</div>';

				count++;
			}
		}

		if ( html ) {
			$el.addClass( 'has-people' );
		} else {
			$el.removeClass( 'has-people' );
		}

		$el.html( html );

		$el.find( '.remove' ).off( 'click', _remove_person );
		$el.find( '.remove' ).on( 'click', _remove_person );

		if ( scroll_to ) {
			$( 'html, body' ).animate( { scrollTop: $el.offset().top - 120 }, 1000 );
		}
	};

	let _remove_person = function( e ) {
		e.preventDefault();

		let type = $( this ).closest( '.co-people' ).attr( 'id' );
		let person_id = $( this ).closest( '.person' ).data( 'id' );

		let $val_field = $( '#' + $form.attr( 'id' ) + '-proposal_' + type );

		let prev_value = JSON.parse( $val_field.val() );
		let new_value = [];

		for ( let value_id in prev_value ) {
			if ( !prev_value.hasOwnProperty( value_id ) ) {
				continue;
			}

			if ( parseInt( value_id ) !== parseInt( person_id ) ) {
				new_value.push( prev_value[ value_id ] );
			}
		}

		$val_field.val( JSON.stringify( new_value ) );

		_update_co_person_html( type.slice( 0, -1 ) );
	};

	let _maybe_move_abstract_tooltips = function() {
		let $desktop_tooltips = $( '.abstract .col-md-3 .tooltip-placeholder' );
		let $responsive_tooltips = $( '.abstract .col-md-9 .tooltip-placeholder' );

		if ( utils.viewport_size().width < 992 ) {
			$desktop_tooltips.addClass( 'hide' );
			$responsive_tooltips.removeClass( 'hide' );
		} else {
			$desktop_tooltips.removeClass( 'hide' );
			$responsive_tooltips.addClass( 'hide' );
		}
	}

	let _move_abstract_tooltips = function() {
		let $desktop_tooltips = $( '.abstract .col-md-3 .tooltip-placeholder' );
		let $responsive_tooltips = $( '.abstract .col-md-9 .tooltip-placeholder' );

		$desktop_tooltips.addClass( 'hide' );
		$responsive_tooltips.removeClass( 'hide' );
	}

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = submit_proposal;